import { useCallback, useRef, useState } from "react";
import { ROUTES as API_ROUTES } from "../../constants/api";
import { PostApiData } from "../../api/general";
import useErrorModal from "../useErrorModal";

// types
import type {
  SendMoneyCommitRequest,
  SendMoneyCommitResponse,
} from "../../types/api/sendMoney";

const useCommitSendMoney = () => {
  const openErrorModal = useErrorModal();
  const [loading, setLoading] = useState(false);

  const inFlight = useRef(false);

  const commitTransfer = useCallback(
    async (body: SendMoneyCommitRequest): Promise<SendMoneyCommitResponse["result"] | null> => {
      if (inFlight.current) return null;
      inFlight.current = true;
      try {
        setLoading(true);
        const response = await PostApiData<SendMoneyCommitRequest, SendMoneyCommitResponse>(
          API_ROUTES.SEND_MONEY.COMMIT,
          body
        );
        return response.result;
      } catch (err) {
        openErrorModal(err);
        return null;
      } finally {
        inFlight.current = false;
        setLoading(false);
      }
    },
    []
  );

  return { loading, commitTransfer };
};

export default useCommitSendMoney;